var map = {
	"./arrow-down-blue.svg": 390,
	"./arrow-down-grey.svg": 391,
	"./arrow-right-white.png": 392,
	"./arrow-right.svg": 393,
	"./blue-loader.svg": 173,
	"./bnb.png": 174,
	"./bnb.svg": 126,
	"./circle-grey.svg": 394,
	"./circle.svg": 395,
	"./coinbaseWalletIcon.svg": 122,
	"./dex.svg": 175,
	"./dropdown-blue.svg": 396,
	"./dropdown.svg": 397,
	"./dropup-blue.svg": 398,
	"./fortmaticIcon.png": 123,
	"./link.svg": 399,
	"./magnifying-glass.svg": 400,
	"./menu.svg": 401,
	"./metamask.png": 176,
	"./plus-blue.svg": 402,
	"./plus-grey.svg": 403,
	"./portisIcon.png": 124,
	"./question-mark.svg": 404,
	"./question.svg": 405,
	"./spinner.svg": 406,
	"./token-list/lists-dark.png": 177,
	"./token-list/lists-light.png": 178,
	"./trustWallet.png": 407,
	"./walletConnectIcon.svg": 125,
	"./x.svg": 408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;